import { render, staticRenderFns } from "./Nueva-nd-desde-venta.vue?vue&type=template&id=eca8b688"
import script from "./Nueva-nd-desde-venta.vue?vue&type=script&lang=js"
export * from "./Nueva-nd-desde-venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports